import { VehicleFeaturesComponent } from './../../vehicles/vehicle-features/vehicle-features.component';
import { AlertInput, loadingController } from '@ionic/core';
import { VehiclePriceSettingsComponent } from './../../vehicles/vehicle-price-settings/vehicle-price-settings.component';
import { VehicleStatusSelectorComponent } from './../../vehicles/vehicle-status-selector/vehicle-status-selector.component';
import { UserService } from 'app/services/user.service';
import { VehicleSummaryModel, VehicleModel } from 'app/models/dms/vehicle.model';

import { Component, Input, Output, OnInit, EventEmitter, ViewChild, ElementRef, ChangeDetectorRef, Renderer2 } from '@angular/core';

import { ListItemModel } from 'app/models/shared/listItem.model';
import { VehicleStatusModel } from 'app/models/dms/vehicleStatus.model';
import { VehicleService } from 'app/services/vehicle.service';

import { DecimalPipe } from '@angular/common';

import { TaxStatusEnum, SecurityRight, VehicleStatusEnum, CustomFieldType, ReportType } from 'app/utility/enums';
import { Constants } from "../../../utility/constants";

import { NavController, AlertController, ActionSheetController, IonCard, PopoverController, ModalController, LoadingController } from '@ionic/angular';

import { VehicleListItemPopover } from './vehicle-list-item.popover';
import { Subscription } from 'rxjs';
import { NativeService } from 'app/services/native.service';
import { CustomFieldResultModel } from 'app/models/shared/customField.model';
import { DateHelper } from 'app/utility/datehelper';
import { StringHelper } from 'app/utility/stringhelper';
import { query } from '@angular/animations';
import { OpportunityActivityResultModel } from 'app/models/dms/opportunityActivityResult.model';
@Component({
    selector: 'app-vehicle-list-item',
    templateUrl: './vehicle-list-item.component.html',
    styleUrls: ['./vehicle-list-item.component.scss'],
    standalone: false
})
export class VehicleListItemComponent implements OnInit
{
    @Input() vehicle: VehicleSummaryModel;
    @Input() statuses: ListItemModel[];
    @Input() allowActions: boolean = false;
    @Output() selectedStatusIdChange: EventEmitter<VehicleStatusModel> = new EventEmitter<VehicleStatusModel>();
    @Output() selected = new EventEmitter<VehicleSummaryModel>();
    @Output() actionSelected = new EventEmitter<any>();
    @Input() modal: boolean = false;
    @Input() display: 'card' | 'grid' = "card";
    @Input() type: 'data' | 'header' | 'skeleton' = "data";
    @Input() customFields: CustomFieldResultModel[];

    vehicleStatus: VehicleStatusModel;

    thumbWidth: number = 56;

    @ViewChild('vehicleCard') vehicleCard: IonCard;
    primaryAttributes: string[];
    secondaryAttributes: string[];
    cardAttributes: string[];


    priceInfoVisible: boolean = false;

    subscription: Subscription;
    allowOpportunities: boolean = false;
    vehicleStatusCaption: string;

    noImageUrl: string = Constants.PlaceholderCarUrl;
    cardThumbUrl: string = "";
    cardClass: string = "opportunity-list-item";
    cardTitle: string = "";
    contactInitials: string = "";
    cardSubRow1: string = "";
    cardSubRow2: string = "";
    cardSubRow3: string = "";
    cardSubRow3Class: string = "";
    statusTitle: string = "";
    readonly vehicleStatusSold = Constants.Vehicle_Status_Sold_Caption;
    statusClass: string = "skeleton";
    vehiclePrice: string = "0";
    vehiclePriceTaxCaption: string = "";
    primaryAttributesCaption: string = "";
    secondaryAttributesCaption: string = "";
    vehicleOrc: string = "";
    vehicleStatusClass: string = "";
    vehicleTapped: boolean = false;
    retailPriceAmountCaption: string = "";
    vehicleClassCaption: string = "";
    vehicleStatusCaptionTrimmed: string = "";
    vehicleActive: boolean = false;
    customFieldsColumnCaption: string = "Custom Fields";
    customFieldRow1: string = "";
    customFieldRow2: string = "";
    customFieldRow3: string = "";

    constructor(
        private vehicleService: VehicleService,
        private decimalPipe: DecimalPipe,
        public navCtrl: NavController,
        public alertController: AlertController,
        public popoverController: PopoverController,
        public renderer: Renderer2,
        public elRef: ElementRef,
        public userService: UserService,
        public modalController: ModalController,
        public loadingController: LoadingController,
        private cd: ChangeDetectorRef,
        private nativeService: NativeService
    ) { }



    ngOnInit()
    {
        if (this.type != 'data')
        {
            return;
        }

        this.vehicleStatus = new VehicleStatusModel();

        if (window.innerWidth > 700)
        {
            // this.thumbWidth = 80;
        }


        this.bind();

        this.allowOpportunities = this.userService.hasUserRight(SecurityRight.OpportTabs);

        if (this.vehicle && this.customFields)
        {
            const customFieldsWithValues = this.customFields
                .map(field => ({ field, value: this.formatCustomColumn(field, this.vehicle) }))
				.filter(customField => customField.value && customField.value !== "-")
                .slice(0, 3);

            this.customFieldRow1 = customFieldsWithValues[0]
                ? `${customFieldsWithValues[0].field.name}: ${customFieldsWithValues[0].value}`
                : '-';
            this.customFieldRow2 = customFieldsWithValues[1]
                ? `${customFieldsWithValues[1].field.name}: ${customFieldsWithValues[1].value}`
                : '';
            this.customFieldRow3 = customFieldsWithValues[2]
                ? `${customFieldsWithValues[2].field.name}: ${customFieldsWithValues[2].value}`
                : '';
        }
    }

	private formatCustomColumn(field: CustomFieldResultModel, vehicle: VehicleSummaryModel): string
	{
		if (!field.visible || !vehicle) return "";

		var fieldValue = vehicle[field.propertyName];
        if (fieldValue === null || fieldValue === undefined || fieldValue === "") return "";

		return StringHelper.formatCustomColumn(field, fieldValue);
	}

    private bind()
    {
        if (this.vehicle)
        {
            var transmissionCaption = this.vehicle.transmissionCaption ? this.vehicle.transmissionCaption : this.vehicle.transmissionParent;
            switch (transmissionCaption)
            {
                case "Manual":
                    transmissionCaption = "Man";
                    break;
                case "Tiptronic":
                    transmissionCaption = "Tip";
                    break;

                case "Automatic":
                    transmissionCaption = "Auto";
                    break;
                case "Other":
                    if (this.vehicle.transmissionParent)
                    {
                        transmissionCaption = this.vehicle.transmissionParent;
                    }
                    break;

            }

            // var fuelTypeCaption = this.vehicle.fuelTypeParent ? this.vehicle.fuelTypeParent : this.vehicle.fuelTypeCaption;
            var fuelTypeCaption = this.vehicle.fuelTypeCaption; // ? this.vehicle.fuelTypeCaption : this.vehicle.fuelTypeParent;
            this.primaryAttributes = [
                this.vehicle.odometerCaption,
                transmissionCaption,
                fuelTypeCaption
            ];
            this.primaryAttributesCaption = this.formatAttributes(this.primaryAttributes);
            this.secondaryAttributes = [
                this.vehicle.extColorCaption,
                this.vehicle.chassisNo,
                this.vehicle.regNo
            ];
            this.secondaryAttributesCaption = this.formatAttributes(this.secondaryAttributes);
            this.vehicleStatus.statusId = this.vehicle.vehicleStatusId;
            this.vehicleStatus.statusComment = this.vehicle.vehicleStatusDesc;
            this.vehicleStatus.supplierId = this.vehicle.vehicleStatusSupId;

            this.vehicleStatusCaption = this.vehicle.vehicleStatusCaption;
            this.vehicleStatusCaptionTrimmed = this.vehicleStatusCaption;

            var bracket = this.vehicleStatusCaption.indexOf(" (");
            if (bracket > 0)
            {
                this.vehicleStatusCaptionTrimmed = this.vehicleStatusCaption.substr(0, bracket);
                // this.vehicleStatusSupCaption = this.vehicleStatusCaption.substr(bracket, this.vehicleStatusCaption.length-1);
            }

            this.cardTitle = this.vehicle.yearManuModelCaption;
            this.statusTitle = this.vehicleStatusCaption;
            this.vehicleStatusClass = this.vehicle.vehicleStatus.caption.toString().toLowerCase().replace(/[^a-z]/g, '').replace(/ /g, '-');
            this.vehicleClassCaption = this.vehicle.vehicleClass.toString().replace(/([A-Z])/g, ' $1').trim();
            this.cardThumbUrl = this.vehicle.vehicleThumbnailUrl;
            this.cardSubRow1 = "#" + this.vehicle.stockNo + " • " + this.vehicle.companyCode;
            this.cardAttributes = [
                this.vehicle.odometerCaption,
                transmissionCaption,
                fuelTypeCaption,
                (this.vehicle.regNo ? this.vehicle.regNo : this.vehicle.vinChassisShortCaption),
            ];
            this.cardSubRow2 = this.formatAttributes(this.cardAttributes);

            this.vehiclePrice = "$" + (this.vehicle.effectivePriceAmount ? this.numberWithCommas(this.vehicle.effectivePriceAmount) : "0");
            switch (this.vehicle.effectivePriceTaxStatusEnum)
            {
                case "POA":
                case "Tender":
                case "Auction":
                    this.vehiclePrice = this.vehicle.effectivePriceTaxStatusEnum;
                    break;
                default:
                    this.vehiclePriceTaxCaption = this.vehicle.effectivePriceTaxStatusDisplay == 'incl' ? '' : this.vehicle.effectivePriceTaxStatusDisplay;
                    this.vehicleOrc = (this.vehicle.orcPriceAmount > 0) ? "+ORC" : "";
                    break;
            }

            if (this.vehicle.vehicleStatusCaption == "Inactive")
            {
                this.vehicle.isActive = false;
                this.vehicleActive = false;
            } else
            {
                this.vehicle.isActive = true;
                this.vehicleActive = true;
            }
        }
    }

    formatAttributes(attributes: string[]): string
    {
        var validAttributes = [];
        for (let a in attributes)
        {
            let val = attributes[a];
            if (val)
            {
                val = val.trim();
            }
            if (val != '' && val != 'Other')
            {
                validAttributes.push(val);
            }
        }
        return validAttributes.join(" • ");
    }

    hasVehicle(): boolean
    {
        if (this.vehicle)
        {
            return true;
        }
        return false;
    }

    showPriceInfo(): void
    {
        this.priceInfoVisible = true;
    }

    formatPrice(price: number): string
    {
        if (price > 0)
        {
            return '$' + this.decimalPipe.transform(price, '2.2-2');
        }
        else
        {
            return '-';
        }
    }

    public rowClicked(ev: any = null, additionalPath: string = '')
    {
        // console.log("rowClicked");
        this.vehicleTapped = true;

        var vehicle = this.vehicle;

        if (this.allowActions)
        {
            if (additionalPath && additionalPath == "opportunities")
            {
                // console.log("nav opportunities path", additionalPath);
                this.navigateForward('/vehicle/' + vehicle.vehicleId + '/opportunities');
            }
            else if (additionalPath)
            {
                // console.log("nav additional path", additionalPath);
                this.navigateForward('/vehicles/' + vehicle.vehicleId + (additionalPath ? '?t=' + additionalPath : ''));
            }
            else
            {
                this.selected.emit(vehicle);
            }
        }
        else
        {
            this.selected.emit(vehicle);
        }
    }

    public navigateForward(page)
    {
        this.navCtrl.navigateForward(page);
    }

    async presentPriceAlert()
    {
        if (!this.userService.hasUserRight(SecurityRight.VehiclesTabsAdmin)) return;
        const alert = await this.alertController.create({
            header: 'Pricing',
            subHeader: this.vehicle.stockNo + ' • ' + this.vehicle.yearManuModelCaption,
            message:
                '<div class="alert-detail-row"><ion-label>Retail</ion-label> <ion-note slot="end">' + this.formatPrice(this.vehicle.retailPriceAmount) + (0 && this.vehicle.retailPriceAmount ? ' ' + TaxStatusEnum[this.vehicle.retailPriceTaxStatusEnum] : '') + '</ion-note></div><br/>'
                + '<div class="alert-detail-row"><ion-label>Wholesale</ion-label> <ion-note slot="end">' + this.formatPrice(this.vehicle.wholesalePriceAmount) + (0 && this.vehicle.wholesalePriceAmount ? ' ' + TaxStatusEnum[this.vehicle.wholesalePriceTaxStatusEnum] : '') + '</ion-note></div><br/>'
                + '<div class="alert-detail-row"><ion-label>Special</ion-label> <ion-note  slot="end">' + this.formatPrice(this.vehicle.specialPriceAmount) + (0 && this.vehicle.specialPriceAmount ? ' ' + TaxStatusEnum[this.vehicle.specialPriceTaxStatusEnum] : '') + '</span></div><br/>'
                + '<div class="alert-detail-row"><ion-label>ORC</ion-label> <ion-note slot="end">' + this.formatPrice(this.vehicle.orcPriceAmount) + (0 && this.vehicle.orcPriceAmount ? ' ' + TaxStatusEnum[this.vehicle.orcPriceTaxStatusEnum] : '') + '</ion></div>'
            ,
            buttons: [
                {
                    text: 'Close',
                    role: 'cancel',
                    cssClass: 'mediumz',
                },
                {
                    text: 'Edit',
                    handler: () =>
                    {
                        this.launchQuickAction("price");
                    }
                }
            ]
        });

        await alert.present();
    }

    async presentStatusAlert()
    {
        if (!this.allowActions)
        {
            return;
        }
        var buttons = [
            {
                text: 'Close',
                role: 'cancel',
                cssClass: 'mediumz',
                handler: () => { }
            },
            {
                text: 'Edit',
                handler: () =>
                {
                    this.launchQuickAction("status");
                }
            }
        ]

        if (!this.userService.hasUserRight(SecurityRight.VehiclesTabsAdmin) || !this.userService.hasUserRight(SecurityRight.VehiclesTabsAdminEdit))
        {
            buttons.pop();
        }

        const alert = await this.alertController.create({
            header: 'Status',
            subHeader: this.vehicle.stockNo + ' • ' + this.vehicle.yearManuModelCaption,
            message:
                '<div class="alert-detail-row ' + this.vehicleStatusCssClass() + '"><label>Status</label> <b class="status-indicator margin-right"></b>  ' + this.vehicle.vehicleStatus.caption + "</span></div><br/>"
                + (this.vehicle.vehicleStatusElapsedDays ? '<div class="alert-detail-row"><label>Status Days</label> <span>' + this.vehicle.vehicleStatusElapsedDays + '</span></div><br/>' : '')
                + (this.vehicle.vehicleStatus.caption == "At Supplier" && this.vehicle.vehicleStatusSupCaption ? '<div class="alert-detail-row"><label>Supplier</label> <span>' + this.vehicle.vehicleStatusSupCaption + '</span></div><br/>' : '')
            ,
            buttons: buttons
        });

        await alert.present();
    }

    popoverPresented: boolean = false;
    async presentPopover(ev: any)
    {
        ev.preventDefault();
        if (!this.popoverController) return
        if (this.popoverPresented)
        {
            return;
        }

        this.popoverPresented = true;

        const popover = await this.popoverController.create({
            component: VehicleListItemPopover,
            componentProps: {
                vehicle: this.vehicle,
                additionalProperties: this.vehicle.isActive,
            },
            event: ev,
            translucent: true
        });

        popover.onDidDismiss().then(
            (d: any) => this.handlePopoverDismiss(d)
        );
        return await popover.present();
    }

    handlePopoverDismiss = ({ data }) =>
    {
        this.popoverPresented = false;

        var reportType: ReportType;

        switch (data)
        {
            case "view":
                this.rowClicked();
                break;
            case "activity":
                this.navCtrl.navigateForward('/vehicles/' + this.vehicle.vehicleId + '/activity/' + this.vehicle.stockNo);
                break;
            case "opportunities":
                this.navCtrl.navigateForward('/vehicles/' + this.vehicle.vehicleId + '/opportunities/' + this.vehicle.stockNo);
                break;
            case "purchase-order":
                this.navCtrl.navigateForward('/purchase-order/new/' + this.vehicle.vehicleId);
                break;
            case "price":
                this.presentPriceAlert();
                break;
            case "status":
                this.presentStatusAlert();
                break;
            case "buyerscore":
                reportType = ReportType.BuyerScoreVehicleReport;
                break;
            case "cinReport":
                reportType = ReportType.Cin;
                break;
            case "fueleconomy":
                reportType = ReportType.FuelEconomyLabel;
                break;
            case "ratings":
                reportType = ReportType.FuelEconomyLabel;
                break;
            case "financial-details":
                reportType = ReportType.FinancialDetails;
                break;
            case "mr1b":
                reportType = ReportType.Mr1bTextOnly;
                break;
            case "purchase-agreement":
                reportType = ReportType.PurchaseAgreement;
                break;
            case "summarysheet":
                reportType = ReportType.SummarySheet;
                break;
            case "stockid":
                reportType = ReportType.StockIdCard;
                break;
            case "change-activation":
                this.toggleVehicleActivation();
                break;
            case "sell":
                this.sellVehicle();
                break;
            case "copy":
                this.copyVehicle();
                break;
            case "delete-vehicle":
                if (this.userService.mcMinVersion("3.2.26"))
                {
                    this.deleteVehicleActivityCheck();
                }
                else
                {
                    this.deleteVehicle();
                }
                break;
        }

        
        if (data && reportType)
        {
            this.actionSelected.emit({ action: reportType, vehicle: this.vehicle });
        }
    }


    public vehicleStatusCssClass(): string
    {
        return this.vehicle.vehicleStatus.caption.toString().toLowerCase().replace(/[^a-z]/g, '').replace(/ /g, '-');
    }
    public numberWithCommas(x: any): string
    {
        var parts = x.toString().split(".");
        parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",");
        return parts.join(".");
    }


    private async launchEditor(modal: any)
    {
        if (this.vehicle.vehicleStatusCaption == Constants.Vehicle_Status_Sold_Caption)
        {
            this.presentAlert("Status Locked", "Vehicle status is set to Sold, so you cannot edit this vehicle in the app.");
            return;
        }

        var statusBarColor = this.nativeService.currentColor;
        this.userService.nativeService.setupStatusBar('dark');
        await modal.present();
        const { data } = await modal.onDidDismiss();
        this.userService.nativeService.setupStatusBar(statusBarColor);

        if (data && data.result && data.result.save)
        {
            // console.log("Edit saved");
            this.fetchingObject = true;
            // this.setEdit(false);
            var imageUrl = this.vehicle.vehicleImageUrl;
            var thumbnailUrl = this.vehicle.vehicleThumbnailUrl;
            this.reloading = true;
            setTimeout(() =>
            {
                this.vehicle = data.result.vehicle.vehicleSummary;
                this.vehicle.vehicleThumbnailUrl = thumbnailUrl;
                this.vehicle.vehicleImageUrl = imageUrl;
                this.bind();
                this.fetchingObject = false;
                this.reloading = false;
                setTimeout(() =>
                {
                    this.cd.detectChanges();
                }, 500);
            }, 50);
        }
        else
        {
            // console.log("Edit cancelled");
        }
    }
    reloading: boolean = false;

    async launchStatusEditor()
    {
        if (!this.userService.hasUserRight(SecurityRight.VehiclesTabsAdmin) || !this.userService.hasUserRight(SecurityRight.VehiclesTabsAdminEdit))
        {
            this.presentAlert("Permission Error", "Sorry you do not have permission to edit vehicle status.");
            return;
        }
        else if (this.vehicle.vehicleStatusCaption == Constants.Vehicle_Status_Sold_Caption)
        {
            this.presentAlert("Sold", "Vehicle is sold so status cannot be altered with quick edit");
            return;
        }

        const modal = await this.modalController.create({
            component: VehicleStatusSelectorComponent,
            componentProps: {
                title: 'Status',
                vehicle: this.fullVehicle
            }
        });
        this.launchEditor(modal);
    }

    async launchFeatureEditor()
    {
        if (!this.userService.hasUserRights([
            SecurityRight.VehiclesTabsInteriorEdit,
            SecurityRight.VehiclesTabsMechanicalEdit
        ]))
        {
            this.presentAlert("Permission Error", "Sorry you do not have permission to edit vehicle features.");
            return;
        }
        else if (this.vehicle.vehicleStatusCaption == Constants.Vehicle_Status_Sold_Caption)
        {
            this.presentAlert("Sold", "Vehicle is sold so status cannot be altered with quick edit");
            return;
        }

        const modal = await this.modalController.create({
            component: VehicleFeaturesComponent,
            componentProps: {
                title: 'Features',
                vehicle: this.fullVehicle
            }
        });
        this.launchEditor(modal);
    }

    async launchPriceEditor()
    {
        if (!this.userService.hasUserRight(SecurityRight.VehiclesTabsAdminEdit))
        {
            this.presentAlert("Permission Error", "Sorry you do not have permission to edit vehicle price.");
            return;
        }
        else if (this.vehicle.vehicleStatusCaption == Constants.Vehicle_Status_Sold_Caption)
        {
            this.presentAlert("Sold", "Vehicle is sold so price cannot be altered with quick edit");
            return;
        }
        const modal = await this.modalController.create({
            component: VehiclePriceSettingsComponent,
            componentProps: {
                title: 'Price',
                vehicle: this.fullVehicle
            }
        });
        this.launchEditor(modal);
    }

    async presentAlert(title: string, message: string, back: boolean = false)
    {
        this.userService.presentAlert(title, message, back);
    }

    fullVehicle: VehicleModel;
    fetchingObject: boolean = false;
    public async launchQuickAction(action: string)
    {
        if (this.fetchingObject) return;
        this.fetchingObject = true;

        this.vehicleService.getVehicleById(this.vehicle.vehicleId)
            .subscribe
            ({
                next: x =>
                {
                    this.fullVehicle = x;
                    this.fetchingObject = false;
                    switch (action)
                    {
                        case "price":
                            this.launchPriceEditor();
                            break;
                        case "status":
                            this.launchStatusEditor();
                            break;
                        case "features":
                            this.launchFeatureEditor();
                            break;
                    }
                },
                error: err =>
                {
                    this.handleError(err);
                }
            });
    }
    public objectLoadError: boolean = false;
    public handleError(error: any): void
    {
        this.objectLoadError = true;
        this.userService.handleError(error);
    }


    async toggleVehicleActivation()
    {
        if (this.vehicle.vehicleStatus.member == VehicleStatusEnum.Sold)
        {
            this.presentAlert("Vehicle sold", "Sold vehicles cannot be deactivated.");
            return;
        }

        const alert = await this.alertController.create({
            header: "Confirm",
            message: "Are you sure you want to change the activation status of this vehicle?",
            buttons: [
                {
                    text: 'No',
                    role: 'cancel',
                    cssClass: 'primary',
                    handler: () =>
                    {
                        return;
                    }
                },
                {
                    text: 'Yes',
                    cssClass: 'danger',
                    handler: async () =>
                    {

                        const loading = await this.loadingController.create({
                            message: 'Saving',
                            duration: 60000
                        });
                        await loading.present();

                        if (!this.userService.hasUserRight(SecurityRight.VehiclesTabsAdminEdit)) return;

                        this.vehicleService.updateVehicleActive(this.vehicle.vehicleId, !this.vehicle.isActive).subscribe({
                            next: x =>
                            {
                                this.vehicle.isActive = x.value;
                                if (x.value == false)
                                {
                                    this.statusTitle = "Inactive";
                                    this.vehicleStatusCaptionTrimmed = "Inactive";
                                    this.vehicleActive = false;
                                } else
                                {
                                    this.statusTitle = this.vehicle.vehicleStatus.caption;
                                    this.vehicleStatusCaptionTrimmed = this.vehicle.vehicleStatus.caption;
                                    this.vehicleActive = true;
                                }
                                loading.dismiss();
                            },
                            error: err =>
                            {
                                loading.dismiss();
                                this.handleError(err);
                            }
                        });

                    }
                }
            ]
        });

        alert.present();

    }

    sellVehicle() 
    {
        this.vehicleService.sellVehicle(this.vehicle);
    }

    async copyVehicle()
    {
        var inputs: AlertInput[] = [];
        if (this.userService.mcMinVersion("3.2.23"))
        {
            inputs.push(
            {
                name: 'includeExportTabFields',
                id: 'includeExportTabFields',
                type: 'checkbox',
                label: 'Include Export tab fields',
                value: true
            });
        }
        const alert = await this.alertController.create({
            header: 'Confirm copy',
            message: 'Are you sure you want to add a new vehicle to stock based on this vehicle?',
            inputs: inputs,
            buttons: [
                {
                    text: 'No',
                    role: 'cancel',
                    cssClass: 'primary',
                    handler: () =>
                    {
                        return;
                    }
                },
                {
                    text: 'Yes',
                    cssClass: 'danger',
                    handler: async (data) =>
                    {
                        let queryParams = undefined;

                        if (this.userService.mcMinVersion("3.2.23")) {
                            const includeExportFields = data?.[0] ?? false;
                            queryParams = { includeExportFields };
                        }

                        this.navCtrl.navigateForward(
                            `/vehicles/${this.vehicle.vehicleId}/copy`,
                            queryParams ? { queryParams } : undefined
                        );
                    }
                }
            ]
        });
        
        await alert.present();
    }

    async deleteVehicleActivityCheck()
    {
        const loading = await this.loadingController.create({
            message: 'Checking...',
            duration: 60000
        });
        await loading.present();

        this.vehicleService.getVehicleActivities(this.vehicle.vehicleId)
            .subscribe({
                next: async activities =>
                {
                    loading.dismiss();
                    if (activities && activities.length > 0)
                    {
                        if (!this.vehicleService.canDeleteVehicleActivities(activities))
                        {
                            this.userService.presentAlert("Insufficient permissions", "You do not have permission to delete this vehicle as it has associated activities that you do not have permission to delete.");
                            return;
                        }
                        else
                        {
                            this.deleteVehicleWithActivities(activities);
                        }
                    }
                    else
                    {
                        this.deleteVehicle();
                    }
                },
                error: err =>
                {
                    loading.dismiss();
                    this.handleError(err);
                }
            });
    }

    async deleteVehicleWithActivities(activities: OpportunityActivityResultModel[])
    {
        var activitiesToDeleteCaption = "";
        for (const activity of activities)
        {
            activitiesToDeleteCaption += "<li>" + activity.caption + "</li>";
        }

        const alert = await this.alertController.create({
            header: 'Delete this vehicle?',
            subHeader: activities[0].vehicleYearManuModelCaption + " • #" + activities[0].vehicleStockNo,
            message: "<br>The following record(s) will also be permanently deleted:<ul>" + activitiesToDeleteCaption + "</ul><br>Enter the reason for deleting this vehicle.<br><br>This action cannot be undone. All associated records will be permanently removed from Motorcentral.",
            inputs: [
                {
                    name: 'reason',
                    type: 'text',
                    placeholder: 'Reason'
                }
            ],
            buttons: [
                {
                    text: 'Cancel',
                    role: 'cancel',
                    cssClass: 'primary',
                    handler: () =>
                    {
                        return;
                    }
                },
                {
                    text: 'Delete',
                    cssClass: 'danger',
                    handler: async (data) =>
                    {
                        const reason = data.reason;
                        if (!reason)
                        {
                            this.userService.presentAlert("No reason provided", "Please provide a reason for deletion.");
                            return;
                        }


                        const loading = await this.loadingController.create({
                            message: 'Deleting...',
                            duration: 60000
                        });
                        await loading.present();

                        this.vehicleService.deleteVehicle(this.vehicle.vehicleId, reason)
                            .subscribe({
                                next: x =>
                                {
                                    this.actionSelected.emit({ action: 'deleted', vehicle: this.vehicle });
                                    loading.dismiss();
                                },
                                error: err =>
                                {
                                    loading.dismiss();
                                    this.handleError(err);
                                }
                            });

                    }
                }
            ]
        });

        alert.present();
    }

    async deleteVehicle()
    {
        const alert = await this.alertController.create({
            header: 'Reason for deletion',
            message: "Enter the reason for deleting this vehicle.",
            inputs: [
                {
                    name: 'reason',
                    type: 'text',
                    placeholder: 'Reason'
                }
            ],
            buttons: [
                {
                    text: 'Cancel',
                    role: 'cancel',
                    cssClass: 'primary',
                    handler: () =>
                    {
                        return;
                    }
                },
                {
                    text: 'Delete',
                    cssClass: 'danger',
                    handler: async (data) =>
                    {
                        const reason = data.reason;
                        if (!reason)
                        {
                            this.userService.presentAlert("No reason provided", "Please provide a reason for deletion.");
                            return;
                        }

                        const loading = await this.loadingController.create({
                            message: 'Deleting...',
                            duration: 60000
                        });
                        await loading.present();

                        this.vehicleService.deleteVehicle(this.vehicle.vehicleId, reason)
                            .subscribe({
                                next: x =>
                                {
                                    this.actionSelected.emit({ action: 'deleted', vehicle: this.vehicle });
                                    loading.dismiss();

                                },
                                error: err =>
                                {
                                    loading.dismiss();
                                    this.handleError(err);
                                }
                            });

                    }
                }
            ]
        });

        alert.present();

    }
}
